import React from 'react';
import { observer } from 'mobx-react';

import Provider from './components';
import CustomCard from '../Common/components/CustomCard';

const Request = () => (
  <CustomCard>
    <Provider />
  </CustomCard>
);

export default observer(Request);
